import { Navigate, RouteObject, useRoutes } from 'react-router-dom';
import ProductManagement from './ProductManagement';

const ProductManagementLayout: RouteObject[] = [
  {
    path: '/',
    element: (
      <ProductManagement />
    ),
  },
  { path: '*', element: <Navigate to="/404" /> },
];

const ProductManagementRoutes = () => useRoutes(ProductManagementLayout);
export default ProductManagementRoutes;
